import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { logBusinessOpportunityArchiveActions } from './slice';
import capabilities from './capabilities';

export const ApiLogBusinessOpportunityArchiveGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(logBusinessOpportunityArchiveActions.startLoading());
    }

    await gestopAPI
        .post('log/businessopportunityarchive/list', { filters, orderBy, groupBy, page, limit }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(logBusinessOpportunityArchiveActions.setList(response?.data?.list));
                    dispatch(logBusinessOpportunityArchiveActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(logBusinessOpportunityArchiveActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(logBusinessOpportunityArchiveActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logBusinessOpportunityArchiveActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiLogBusinessOpportunityArchiveCountCollection = async ({
    filters = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('log/businessopportunityarchive/count', { filters }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiLogBusinessOpportunityArchiveExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(logBusinessOpportunityArchiveActions.startExporting());
    }

    await gestopAPI
        .post(
            'log/businessopportunityarchive/export',
            { exportType, format, columns, filters, orderBy, groupBy },
            { ...config, responseType: 'blob' }
        )
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(logBusinessOpportunityArchiveActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(logBusinessOpportunityArchiveActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logBusinessOpportunityArchiveActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiLogBusinessOpportunityArchiveExportItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(logBusinessOpportunityArchiveActions.startExporting());
    }

    await gestopAPI
        .get(`log/businessopportunityarchive/export/${id}`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(logBusinessOpportunityArchiveActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(logBusinessOpportunityArchiveActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logBusinessOpportunityArchiveActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiLogBusinessOpportunityArchiveGetItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(logBusinessOpportunityArchiveActions.startLoading());
    }

    await gestopAPI
        .get(`log/businessopportunityarchive/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(logBusinessOpportunityArchiveActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(logBusinessOpportunityArchiveActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(logBusinessOpportunityArchiveActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
